enum COOKIE_CONSENT_KEYS {
    GYM_CONSENT_MANDATORY_OPTIN = 'GYM_CONSENT_MANDATORY_OPTIN',
    GYM_CONSENT_MARKETING_OPTIN = 'GYM_CONSENT_MARKETING_OPTIN',
    GYM_CONSENT_ANALYTICS_OPTIN = 'GYM_CONSENT_ANALYTICS_OPTIN',
    GYM_CONSENT_SOCIAL_LOGIN_OPTIN = 'GYM_CONSENT_SOCIAL_LOGIN_OPTIN',
    GYM_CONSENT_FIRST_PARTY_DATA_OPTIN = 'GYM_CONSENT_FIRST_PARTY_DATA_OPTIN',
}

export default COOKIE_CONSENT_KEYS
